
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 4.031c.765 0 1.517.298 2.094.875a2.966 2.966 0 010 4.188L17 19.219l-.313.063-3.5.688-1.469.313.313-1.469.688-3.5.063-.313.219-.219 9.906-9.875a2.951 2.951 0 012.094-.875zm0 1.938c-.235 0-.464.121-.688.344l-9.688 9.688-.344 1.719 1.719-.344 9.688-9.688c.446-.446.446-.929 0-1.375-.223-.223-.453-.344-.688-.344zM4 8h13.188l-2 2H6v16h16v-9.188l2-2V28H4V8z"}})])
          )
        }
      }
    